__turbopack_context__.v({
  "body": "ScriptStep-module__utsG5G__body",
  "bodySplit": "ScriptStep-module__utsG5G__bodySplit",
  "line": "ScriptStep-module__utsG5G__line",
  "marker": "ScriptStep-module__utsG5G__marker",
  "step": "ScriptStep-module__utsG5G__step",
  "timeline": "ScriptStep-module__utsG5G__timeline",
});
